<template>
  <div class="file-edit">
    <style-bar :css-keys="['background', 'color']" class="mb-2" mode="text" :styles.sync="localStyles"></style-bar>

    <v-text-field class="text-field mt-2 pt-5 px-2" hide-details placeholder="Download PDF" v-model="form.content" :label="$t('file_text')"></v-text-field>

    <rich-text-input ref="urlInput" class="py-2 px-2" placeholder="https://www.example.com/file.pdf" :content.sync="form.url" mode="url" :json.sync="editorContentJson" :label="$t('file_link')"></rich-text-input>
  </div>
</template>

<script>

import RichTextInput from '@/components/utils/RichTextInput'
import StyleBar from '@/components/utils/StyleBar'

export default {
  name: 'FileEdit',
  props: ['content', 'url', 'styles'],
  components: {
    'rich-text-input': RichTextInput,
    StyleBar
  },
  watch: {
    styles (newVal) {
      this.localStyles = this.styles ? JSON.parse(JSON.stringify(this.styles)) : {}
    }
  },
  data () {
    return {
      form: {
        content: '',
        url: ''
      },
      localStyles: {},
      editorContentJson: {}
    }
  },
  methods: {
    setUrl (url) {
      if (this.$refs.urlInput) {
        this.$refs.urlInput.updateContent(url, true)
      } else {
        this.form.url = url
      }
    },
    setContent (content) {
      this.form.content = content
    }
  },
  created () {
    this.form.content = this.content
    if (typeof this.form.content !== 'string') {
      this.form.content = ''
    }
    this.form.url = this.url

    if (this.styles) {
      this.localStyles = JSON.parse(JSON.stringify(this.styles))
    }
  }
}
</script>

<style lang="sass" scoped>

.file-edit
  background: #f1f1f1

.text-field
  background: white

</style>
